import { JSX } from 'react';

type Props = {
  content?: JSX.Element | string;
};

const ContentSCG = ({ content }: Props) => {
  return <div>{content}</div>;
};

export default ContentSCG;
